import moment from 'moment';


export const DIFF_COLORS = {
    unknown: { border: '#163b61', backgroundColor: '#9dc5ff' }, // azul - sin dato
    early: { border: '#cc9c00', backgroundColor: '#ffe798' }, // amarillo - salió muy temprano
    onTime: { border: '#065f46', backgroundColor: '#d1fae5' }, // verde - dentro de márgenes
    late: { border: '#ff185d', backgroundColor: '#fde1f0' }, // rojo - llegó tarde
};

export const calcDiffColor = (ticket, atts_for_ui) => {

    const baseStyle = {
        // borderStyle: 'solid',
        borderWidth: '3px',
        marginBottom: '3px',
        borderRadius: '8px',
    };

    if (ticket.enterTime === undefined || ticket.enterTime === null) {
        return { ...baseStyle, ...DIFF_COLORS.unknown };
    }

    const diffMinutes = parseInt(
        moment
            .duration(
                moment(ticket.enterTime).tz('America/Mexico_City')
                    .diff(moment(ticket.expectedTime).tz('America/Mexico_City'))
            )
            .asMinutes(),
        10
    );

    const { earlyDepartureMargin, lateArrivalMargin } = atts_for_ui;

    let colors;
    if (diffMinutes <= earlyDepartureMargin) {
        colors = DIFF_COLORS.early;   // <= -2 → amarillo
    } else if (diffMinutes <= lateArrivalMargin) {
        colors = DIFF_COLORS.onTime;  // entre -2 y 1 → verde
    } else {
        colors = DIFF_COLORS.late;    // > 1 → rojo
    }

    return { ...baseStyle, ...colors };
};